// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__pWMMi","checked":"Checkbox_checked__uSj5V","checkmark":"Checkbox_checkmark__qFsYo"};